export const ACTIVE_COLOR = '#f6c523a6'
